// extracted by mini-css-extract-plugin
export default {"input":"Input_input__1HDO2","extraSmall":"Input_extraSmall__AhBwN","small":"Input_small__7yCWw","middle":"Input_middle__SR49B","large":"Input_large__p2Tk5"};